import { jsx as r } from "react/jsx-runtime";
import { SVG as e, Path as f } from "../template.js";
const n = ({ pathProps: t, ...o }) => /* @__PURE__ */ r(e, { ...o, children: /* @__PURE__ */ r(f, { d: "M16 10H3M20 6H3M20 14H3M16 18H3", ...t }) });
export {
  n as default
};
